import { Box, Hidden, Typography } from "@material-ui/core";
import React from "react";
import { graphql } from "gatsby";
import { ContentGuideFragment as Props } from "./__generated__/ContentGuideFragment";
import {
  ImageWrapper,
  ContentPreTitle,
  ContentTextTitle,
  VideoWrapper,
  VideoContent
} from "./styles";
import { convertDatoCmsAssetUrlToCloudfrontUrl } from "../../helpers/cdn";

const ContentGuide: React.FunctionComponent<Props> = ({
  titlePrefix,
  title,
  body,
  asset,
  assetLayout
}) => {
  const getLayout = (layout: string) => {
    return layout === "right" ? "row" : "row-reverse";
  };
  return (
    <Box
      display={{ xs: "grid", sm: "flex" }}
      justifyContent="space-between"
      maxHeight={{ md: "536px" }}
      minHeight={{ xs: "536px", sm: "398px" }} // Mobile needs larger height
      borderRadius="3px 3px 3px 3px"
      flexDirection={getLayout(assetLayout)}
      bgcolor="#F3F0E9"
      overflow="hidden"
      height={{ md: "536px" }} // Explicit for Safari
    >
      <Box
        display="flex"
        width={{ xs: "100%", sm: "50%", md: "60%" }}
        flexDirection="column"
        justifyContent="space-between"
        padding={{ xs: 2, sm: 4, md: 6 }}
      >
        <Box color="#71695C">
          <ContentPreTitle>{titlePrefix.toUpperCase()}</ContentPreTitle>
          <Hidden implementation="css" smDown>
            <Typography variant="h3">{title}</Typography>
          </Hidden>
          <Hidden implementation="css" mdUp>
            <ContentTextTitle>{title}</ContentTextTitle>
          </Hidden>
        </Box>
        <Box paddingBottom={{ xs: 2, sm: 0 }} paddingTop={{ xs: 2, sm: 0 }}>
          <Hidden implementation="css" smDown>
            <Typography variant="h5">{body}</Typography>
          </Hidden>
          <Hidden implementation="css" mdUp>
            <Typography variant="h6">{body}</Typography>
          </Hidden>
        </Box>
      </Box>
      {asset?.url && asset.isImage ? (
        <ImageWrapper
          src={asset.url}
          imgixParams={{
            auto: "format,compress"
          }}
        />
      ) : (
        <VideoWrapper>
          <VideoContent autoPlay muted loop playsInline>
            <source
              src={convertDatoCmsAssetUrlToCloudfrontUrl(asset.url)}
              type="video/mp4"
            />
          </VideoContent>
        </VideoWrapper>
      )}
    </Box>
  );
};

export const ContentGuideFragment = graphql`
  fragment ContentGuideFragment on DatoCmsCModuleContentGuide {
    titlePrefix
    title
    body
    asset {
      url
      isImage
    }
    assetLayout
    container
    containerDisableGutters
    containerBackgroundColor
    model {
      id
      apiKey
    }
  }
`;

export default React.memo(ContentGuide);
